<template>
  <div>
    <a-select
      :class="class"
      class="w100"
      :value="value"
      allow-clear
      show-search
      :multiple="false"
      :placeholder="placeholder"
      option-filter-prop="title"
      @change="onChange"
      @clear="onClear"
    >
      <a-select-option
        v-for="item in data?.records"
        :key="item.id"
        :value="item.id"
        :title="item.name"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, watch } from "vue";
import { CompanyContactService } from "@/views/cooperation/company/company-contact.service";
import { SelectProps, Form } from "ant-design-vue";
/**
 * 结算单位选择器
 *
 * 使用方式:
 * <unit-select v-model:value="formRef.unitId"></unit-select>
 */
export default defineComponent({
  isGlobal: true,
  name: "CoopCompanyUser",
  props: {
    value: { type: String, default: undefined },
    id: { type: String },
    class: { type: String, default: "append-to-parentnode" },
    placeholder: { type: String, default: "请选择" },
  },
  emits: ["update:value", "change"],
  setup(props, { attrs, slots, emit }) {
    const { data, run, loading } = CompanyContactService.useListApi();
    const formItemContext = Form.useInjectFormItemContext();
    const onChange = (id, option) => {
      emit("update:value", id);
      const { mobile, name, landline } = data?.value?.records.find((v) => v.id == id) || {
        mobile: "",
      };
      emit("change", { id, mobile: mobile || landline, name });
      formItemContext.onFieldChange();
    };

    const onClear = () => {
      emit("update:value", undefined);
      emit("change", undefined);
    };
    watch(
      () => props.id,
      async (n, o) => {
        if (n && n != "" && n != o) {
          await run(props.id);
          formItemContext.onFieldChange();
        }
        // if(n && n == ''){
        //   data?.rec
        // }
      },
      { immediate: true }
    );
    onMounted(async () => {});
    return {
      data,
      loading,
      onChange,
      onClear,
    };
  },
});
</script>
